import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { drawerBodyInjectionKey as q } from "../../drawer/src/interface.js";
import { modalBodyInjectionKey as G } from "../../modal/src/interface.js";
import { popoverBodyInjectionKey as Q } from "./interface.js";
import Y from "./styles/index.cssr.js";
import Z from "../../_mixins/use-config.js";
import L from "../../_mixins/use-theme.js";
import z from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/clickoutside.js";
import ee from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/mousemoveoutside.js";
import { formatLength as O } from "../../_utils/css/format-length.js";
import { useThemeClass as oe } from "../../_mixins/use-css-vars-class.js";
import { getPreciseEventTarget as D } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { useAdjustedTo as E } from "../../_utils/composable/use-adjusted-to.js";
import te from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Follower.js";
import re from "../styles/light.js";
import { isJsdom as ne } from "../../_utils/env/is-jsdom.js";
import { isSlotEmpty as F, resolveWrappedSlot as x } from "../../_utils/vue/resolve-slot.js";
import { FocusTrap as ae } from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/focus-trap/src/index.js";
import { XScrollbar as ie } from "../../_internal/scrollbar/src/Scrollbar.js";
import { defineComponent as le, inject as se, watchEffect as de, computed as T, onBeforeUnmount as ue, watch as ce, provide as _, h as i, mergeProps as fe, withDirectives as ve, Fragment as he } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as y, toRef as me } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { vShow as we, Transition as ye } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const pe = Object.assign(Object.assign({}, L.props), {
  to: E.propTo,
  show: Boolean,
  trigger: String,
  showArrow: Boolean,
  delay: Number,
  duration: Number,
  raw: Boolean,
  arrowPointToCenter: Boolean,
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  displayDirective: String,
  x: Number,
  y: Number,
  flip: Boolean,
  overlap: Boolean,
  placement: String,
  width: [Number, String],
  keepAliveOnHover: Boolean,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  // private
  internalDeactivateImmediately: Boolean,
  animated: Boolean,
  onClickoutside: Function,
  internalTrapFocus: Boolean,
  internalOnAfterLeave: Function,
  // deprecated
  minWidth: Number,
  maxWidth: Number
});
function ge({
  arrowClass: e,
  arrowStyle: l,
  arrowWrapperClass: p,
  arrowWrapperStyle: g,
  clsPrefix: f
}) {
  return i("div", {
    key: "__popover-arrow__",
    style: g,
    class: [`${f}-popover-arrow-wrapper`, p]
  }, i("div", {
    class: [`${f}-popover-arrow`, e],
    style: l
  }));
}
const Le = le({
  name: "PopoverBody",
  inheritAttrs: !1,
  props: pe,
  setup(e, {
    slots: l,
    attrs: p
  }) {
    const {
      namespaceRef: g,
      mergedClsPrefixRef: f,
      inlineThemeDisabled: j
    } = Z(e), H = L("Popover", "-popover", Y, re, e, f), M = y(null), n = se("NPopover"), b = y(null), C = y(e.show), h = y(!1);
    de(() => {
      const {
        show: o
      } = e;
      o && !ne() && !e.internalDeactivateImmediately && (h.value = !0);
    });
    const K = T(() => {
      const {
        trigger: o,
        onClickoutside: r
      } = e, a = [], {
        positionManuallyRef: {
          value: t
        }
      } = n;
      return t || (o === "click" && !r && a.push([z, k, void 0, {
        capture: !0
      }]), o === "hover" && a.push([ee, J])), r && a.push([z, k, void 0, {
        capture: !0
      }]), (e.displayDirective === "show" || e.animated && h.value) && a.push([we, e.show]), a;
    }), N = T(() => {
      const {
        common: {
          cubicBezierEaseInOut: o,
          cubicBezierEaseIn: r,
          cubicBezierEaseOut: a
        },
        self: {
          space: t,
          spaceArrow: S,
          padding: B,
          fontSize: c,
          textColor: m,
          dividerColor: u,
          color: v,
          boxShadow: w,
          borderRadius: R,
          arrowHeight: $,
          arrowOffset: d,
          arrowOffsetVertical: X
        }
      } = H.value;
      return {
        "--n-box-shadow": w,
        "--n-bezier": o,
        "--n-bezier-ease-in": r,
        "--n-bezier-ease-out": a,
        "--n-font-size": c,
        "--n-text-color": m,
        "--n-color": v,
        "--n-divider-color": u,
        "--n-border-radius": R,
        "--n-arrow-height": $,
        "--n-arrow-offset": d,
        "--n-arrow-offset-vertical": X,
        "--n-padding": B,
        "--n-space": t,
        "--n-space-arrow": S
      };
    }), P = T(() => {
      const o = e.width === "trigger" ? void 0 : O(e.width), r = [];
      o && r.push({
        width: o
      });
      const {
        maxWidth: a,
        minWidth: t
      } = e;
      return a && r.push({
        maxWidth: O(a)
      }), t && r.push({
        maxWidth: O(t)
      }), j || r.push(N.value), r;
    }), s = j ? oe("popover", void 0, N, e) : void 0;
    n.setBodyInstance({
      syncPosition: V
    }), ue(() => {
      n.setBodyInstance(null);
    }), ce(me(e, "show"), (o) => {
      e.animated || (o ? C.value = !0 : C.value = !1);
    });
    function V() {
      var o;
      (o = M.value) === null || o === void 0 || o.syncPosition();
    }
    function A(o) {
      e.trigger === "hover" && e.keepAliveOnHover && e.show && n.handleMouseEnter(o);
    }
    function I(o) {
      e.trigger === "hover" && e.keepAliveOnHover && n.handleMouseLeave(o);
    }
    function J(o) {
      e.trigger === "hover" && !W().contains(D(o)) && n.handleMouseMoveOutside(o);
    }
    function k(o) {
      (e.trigger === "click" && !W().contains(D(o)) || e.onClickoutside) && n.handleClickOutside(o);
    }
    function W() {
      return n.getTriggerElement();
    }
    _(Q, b), _(q, null), _(G, null);
    function U() {
      if (s == null || s.onRender(), !(e.displayDirective === "show" || e.show || e.animated && h.value))
        return null;
      let r;
      const a = n.internalRenderBodyRef.value, {
        value: t
      } = f;
      if (a)
        r = a(
          // The popover class and overlap class must exists, they will be used
          // to place the body & transition animation.
          // Shadow class exists for reuse box-shadow.
          [`${t}-popover-shared`, s == null ? void 0 : s.themeClass.value, e.overlap && `${t}-popover-shared--overlap`, e.showArrow && `${t}-popover-shared--show-arrow`, e.arrowPointToCenter && `${t}-popover-shared--center-arrow`],
          b,
          P.value,
          A,
          I
        );
      else {
        const {
          value: S
        } = n.extraClassRef, {
          internalTrapFocus: B
        } = e, c = !F(l.header) || !F(l.footer), m = () => {
          var u, v;
          const w = c ? i(he, null, x(l.header, (d) => d ? i("div", {
            class: [`${t}-popover__header`, e.headerClass],
            style: e.headerStyle
          }, d) : null), x(l.default, (d) => d ? i("div", {
            class: [`${t}-popover__content`, e.contentClass],
            style: e.contentStyle
          }, l) : null), x(l.footer, (d) => d ? i("div", {
            class: [`${t}-popover__footer`, e.footerClass],
            style: e.footerStyle
          }, d) : null)) : e.scrollable ? (u = l.default) === null || u === void 0 ? void 0 : u.call(l) : i("div", {
            class: [`${t}-popover__content`, e.contentClass],
            style: e.contentStyle
          }, l), R = e.scrollable ? i(ie, {
            contentClass: c ? void 0 : `${t}-popover__content ${(v = e.contentClass) !== null && v !== void 0 ? v : ""}`,
            contentStyle: c ? void 0 : e.contentStyle
          }, {
            default: () => w
          }) : w, $ = e.showArrow ? ge({
            arrowClass: e.arrowClass,
            arrowStyle: e.arrowStyle,
            arrowWrapperClass: e.arrowWrapperClass,
            arrowWrapperStyle: e.arrowWrapperStyle,
            clsPrefix: t
          }) : null;
          return [R, $];
        };
        r = i("div", fe({
          class: [`${t}-popover`, `${t}-popover-shared`, s == null ? void 0 : s.themeClass.value, S.map((u) => `${t}-${u}`), {
            [`${t}-popover--scrollable`]: e.scrollable,
            [`${t}-popover--show-header-or-footer`]: c,
            [`${t}-popover--raw`]: e.raw,
            [`${t}-popover-shared--overlap`]: e.overlap,
            [`${t}-popover-shared--show-arrow`]: e.showArrow,
            [`${t}-popover-shared--center-arrow`]: e.arrowPointToCenter
          }],
          ref: b,
          style: P.value,
          onKeydown: n.handleKeydown,
          onMouseenter: A,
          onMouseleave: I
        }, p), B ? i(ae, {
          active: e.show,
          autoFocus: !0
        }, {
          default: m
        }) : m());
      }
      return ve(r, K.value);
    }
    return {
      displayed: h,
      namespace: g,
      isMounted: n.isMountedRef,
      zIndex: n.zIndexRef,
      followerRef: M,
      adjustedTo: E(e),
      followerEnabled: C,
      renderContentNode: U
    };
  },
  render() {
    return i(te, {
      ref: "followerRef",
      zIndex: this.zIndex,
      show: this.show,
      enabled: this.followerEnabled,
      to: this.adjustedTo,
      x: this.x,
      y: this.y,
      flip: this.flip,
      placement: this.placement,
      containerClass: this.namespace,
      overlap: this.overlap,
      width: this.width === "trigger" ? "target" : void 0,
      teleportDisabled: this.adjustedTo === E.tdkey
    }, {
      default: () => this.animated ? i(ye, {
        name: "popover-transition",
        appear: this.isMounted,
        // Don't use watch to enable follower, since the transition may
        // make position sync timing very subtle and buggy.
        onEnter: () => {
          this.followerEnabled = !0;
        },
        onAfterLeave: () => {
          var e;
          (e = this.internalOnAfterLeave) === null || e === void 0 || e.call(this), this.followerEnabled = !1, this.displayed = !1;
        }
      }, {
        default: this.renderContentNode
      }) : this.renderContentNode()
    });
  }
});
export {
  Le as default,
  pe as popoverBodyProps,
  ge as renderArrow
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popover/src/PopoverBody.js
// module id = 967
// module chunks = 67